/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import FeelingEvasSliderComponent, {
  type FeelingEvasSlidersSignature
} from "../component";

export default class FeelingEvasMoodSlider extends FeelingEvasSliderComponent<FeelingEvasSlidersSignature> {
  static min = 0;
  static max = 10;
}
